<template>
  <div>
    <div
      v-if="!loading || tableData.length === 0"
      class="flex flex-col justify-center items-center h-full mt-5"
    >
      <el-empty :image-size="70" description="No Data"></el-empty>
    </div>
    <div v-else>
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Fixed Hours",
  data() {
    return {
      loading: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "Day", key: "a", title: "Day" },
        { field: "StartTime", key: "b", title: "Start Time" },
        { field: "EndTime", key: "c", title: "End Time" },
        {
          field: "WorkType",
          key: "x",
          title: "Work Type",
        },
        { field: "ApplicableTo", key: "d", title: "Applicable To" },

        {
          field: "Action",
          key: "f",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],
      tableData: [],
    };
  },
};
</script>

<style scoped></style>
